import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CallsAPI } from './abstract/http/calls-api';
import { HttpOptions } from './abstract/http/http-api.service';
import { SessionResponseModel } from '../models/sessionResponseModel';

@Injectable({
  providedIn: 'root'
})
export class LiveServiceHttpService extends CallsAPI<SessionResponseModel, SessionResponseModel[]> {
  protected apiBasePath: string = environment.api_url;
  protected resourcePath: string = '';
  /**
   * Default Options per Request
   * @protected
   * @type {HttpOptions}
   * @memberof HttpApiService
   */
  protected override defaultOptions: HttpOptions = {
    withCredentials: true
  };

  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public checkSession(options?: HttpOptions): Observable<SessionResponseModel> {
    return this.http.get<SessionResponseModel>(this.buildAction('session'), this.buildOptions(options));
  }

  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public refreshToken(options?: HttpOptions): Observable<SessionResponseModel> {
    return this.http.post<SessionResponseModel>(this.buildAction('refresh'), {}, this.buildOptions(options));
  }

  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public blacklistToken(options?: HttpOptions): Observable<SessionResponseModel> {
    return this.http.post<SessionResponseModel>(this.buildAction('terminate'), {}, this.buildOptions(options));
  }

  /**
   * @param {*} body
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public activateOTP(body: any, options?: HttpOptions): Observable<SessionResponseModel> {
    return this.http.post<SessionResponseModel>(this.buildAction('init'), body, this.buildOptions(options));
  }
}
